import { observable, action, makeObservable, makeAutoObservable } from 'mobx';
import AppStore from 'Stores/AppStore';
import FiltersStore from 'Stores/Metrics/FiltersStore';
import MetricsRequests from 'Utils/Requests/MetricsRequests';

class UserMetricsStore {
    dataLoading;
    exportLoading;
    data;
    graphsWidth;

    constructor() {
        makeAutoObservable(this);
        this.ClearStore();
    }

    ClearStore() {
        this.metricUserId = -1;
        this.userId = -1;
        this.dataLoading = true;
        this.exportLoading = false;
        this.data = null;
        this.graphsWidth = 1000;
    }

    GetInitData() {
        MetricsRequests.GetMetricUserInfo(this.metricUserId, this.userId).then(action(values => {
            AppStore.pageTitleAdditionalInfo = ` - ${values.userTitle}`;
        }));
    }

    GetData = action(() => {
        this.dataLoading = true;

        MetricsRequests.GetData(FiltersStore.filters, [this.metricUserId]).then(action(values => {
            this.data = Object.values(values.data).find(_ => true);

            this.dataLoading = false;
        }));
    });

    ExportUsersData = action(() => {
        MetricsRequests.ExportUsersData(FiltersStore.filters, [this.metricUserId]);
    });
}

export default new UserMetricsStore();